/* Handles card flip interactions */

class FlipCards {
  constructor(container) {
    this.container = container;
    this.cards = container.querySelectorAll('[data-flip-card]');

    this.init();
  }

  init() {
    if (!this.cards || this.cards.length === 0) {
      return;
    }
    this.cards.forEach(card => {
      const bb = card.getBoundingClientRect();
      card.style = `--card-width: ${bb.width}px; --card-height: ${bb.height}px`;
    });

    this.attachEventListeners();
  }

  attachEventListeners() {
    window.addEventListener('resize', () => {
      this.cards.forEach(card => {
        const bb = card.getBoundingClientRect();
        card.style = `--card-width: ${bb.width}px; --card-height: ${bb.height}px`;
      });
    });
    this.cards.forEach((card) => {
      const button = card.querySelector('button');
      button.addEventListener('click', () => {
        this.toggleFlip(card);
      });

      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleFlip(card);
        }
      });
    });
  }

  toggleFlip(card) {
    const isFlipped = card.classList.contains('is-flipped');

    const label = card.getAttribute('aria-label');
    if (isFlipped) {
      card.setAttribute('aria-label', label.replace('View front', 'Flip card to view'));
    } else {
      card.setAttribute('aria-label', label.replace('Flip card to view', 'View front of'));
    }

    card.classList.toggle('is-flipped');

    this.announceFlip(card, !isFlipped);
  }

  announceFlip(card, isFlipped) {
    let liveRegion = this.container.querySelector('.flip-cards-live-region');

    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'flip-cards-live-region visually-hidden';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      this.container.appendChild(liveRegion);

      const style = document.createElement('style');
      style.textContent = `
        .visually-hidden,
        .flip-cards-live-region {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `;
      if (!document.querySelector('#flip-cards-a11y-styles')) {
        style.id = 'flip-cards-a11y-styles';
        document.head.appendChild(style);
      }
    }

    liveRegion.textContent = isFlipped ? 'Card flipped to back' : 'Card flipped to front';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.flip-cards__container');

  containers.forEach((container) => {
    new FlipCards(container);
  });
});

if (typeof module !== 'undefined' && module.exports) {
  module.exports = FlipCards;
}
